import React from "react";
import InputText from "../../../common/Input/InputText";
import styles from "../editLabReport.module.scss";

const sectionConfig = {
  "PHYSICAL EXAMINATION": [
    "Volume",
    "Colour",
    "Appearance",
    "Clot",
  ],
  "BIOCHEMICAL EXAMINATION": [
    "Protein",
    "Sugar",
  ],
  "MICROSCOPIC EXAMINATION": [
    "Total Cell",
    "Neutrophils",
    "Lymphocytes",
    "Eosinophils",
    "Macrophages Cell",
    "Abnormal Cell",
    "RBC",
    "Comment",
  ],
};

const SynovialFluidProfile = ({
  profile,
  testMap,
  handleTestProfileChange,
}) => {
  const renderField = (item, index) => {
    const testData = testMap.get(item._id) || {};
    const isComment = item?.testName?.toLowerCase() === "comment";

    return (
      <div className={styles.testAndProfileWrapper} key={index}>
        {/* Test Name */}
        <div className={styles["inputWrapper"]}>
          <InputText value={item?.testName} readOnly label="Test Name" />
        </div>

        {/* Value */}
        <div className={styles["inputWrapper"]}>
          {isComment ? (
            <textarea
              value={testData.value || ""}
              onChange={(e) =>
                handleTestProfileChange(
                  e,
                  "value",
                  profile._id,
                  item._id
                )
              }
              rows={2}
              style={{
                width: "250px",
                padding: "6px",
                borderRadius: "6px",
                border: "1px solid #ccc",
              }}
            />
          ) : (
            <InputText
              value={testData.value || ""}
              onChange={(e) =>
                handleTestProfileChange(
                  e,
                  "value",
                  profile._id,
                  item._id
                )
              }
              label="Value"
            />
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      {Object.keys(sectionConfig).map((section) => {
        const sectionTests = profile?.tests?.filter((test) =>
          sectionConfig[section].includes(test.testName)
        );

        if (!sectionTests?.length) return null;

        return (
          <div key={section}>
            <h4 style={{ marginTop: "20px", fontWeight: "600" }}>
              {section}
            </h4>

            {sectionTests.map((item, index) =>
              renderField(item, index)
            )}
          </div>
        );
      })}
    </>
  );
};

export default SynovialFluidProfile;